import { motion } from 'framer-motion';
import { FaGithub, FaLinkedinIn } from 'react-icons/fa';
import { FiGlobe } from 'react-icons/fi';
import './Footer.css';

const socialLinks = [
  { label: 'GitHub', href: 'https://github.com/shyamranjan-sr', icon: FaGithub },
  { label: 'LinkedIn', href: 'https://linkedin.com/in/shyamranjan-sr', icon: FaLinkedinIn },
  { label: 'Website', href: 'https://shyam.ranjansolution.in', icon: FiGlobe },
];

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner section">
        <motion.div
          className="footer__top"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <h3 className="footer__title" >Let&apos;s build something great.</h3>
          <p className="footer__subtitle">
            Open to new opportunities and collaborations.
          </p>
          <div className="footer__social">
            {socialLinks.map((link, i) => {
              const Icon = link.icon;
              return (
                <motion.a
                  key={link.label}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer__social-link"
                  aria-label={link.label}
                  whileHover={{ y: -3, scale: 1.05 }}
                  whileTap={{ scale: 0.98 }}
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.1 * i }}
                >
                  <Icon className="footer__social-icon" aria-hidden />
                  {link.label}
                </motion.a>
              );
            })}
          </div>
        </motion.div>
        <div className="footer__bottom">
          <p>© {new Date().getFullYear()} Shyam Ranjan. </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
